import React from "react";
import Api from "../utils/Api";
import exclamationIcon from "../../images/error.svg";
import { Box, Button } from "@familyzone/component-library";
import LayoutConfig from "../utils/LayoutConfig";
import CardBasedPage from "./templates/CardBasedPage";
import { withToast } from "../utils/ReactUtil";
import { useSessionStore } from "../storez/SessionStore";

class Account extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      phoneNumber: "",
      saving: false,
      changes: false,
      isSupportAdmin: useSessionStore.getState().isSupportAdmin(),
      username: useSessionStore.getState().getUser().username,
      qauthPasswordEmailSent: false,
    };
    this.unsubAccountStore = null;
  }

  componentDidMount = () => {
    Api.get("/settings/ajax/account", (result) => {
      const user = result["result"];
      this.setState({
        phoneNumber: user["phone_number"],
      });
    });
  };

  handleSave = () => {
    const data = {
      phone_number: this.state.phoneNumber,
    };

    if (this.state.saving || !this.state.changes) {
      return;
    }

    this.setState({ saving: true });

    Api.post(
      "/settings/ajax/account",
      data,
      (_r) => {
        this.setState({
          saving: false,
          changes: false,
        });
      },
      (r, e) => {
        this.setState({ saving: false, changes: true });

        this.props.errorToast({
          title: "Please try again",
          description: "Failed to update account settings",
          isClosable: true,
        });
      }
    );
  };

  handleChangePasswordQAuth = async (e) => {
    try {
      await fetch(LayoutConfig.qauthForgotPasswordLink(), {
        method: "POST",
        body: JSON.stringify({
          email: this.state.username,
          redirecturl: window.location.href.replace("/account", "/login/redirect/callback"),
        }),
      });
      this.setState({
        qauthPasswordEmailSent: true,
      });
    } catch (e) {
      console.error(e);
    }
  };

  handleChangePhoneNumber = (event) => {
    this.setState({
      phoneNumber: event.target.value,
      changes: true,
    });
  };

  render = () => {
    return (
      <CardBasedPage title={"Account Settings"}>
        <Box>
          <Box>
            <form className="mui-form" id="accountSettings">
              <div className="formgroup">
                <div className="formgroup_title">
                  <div className="formgroup_title_title">Change Password</div>
                </div>
                {this.state.isSupportAdmin ? (
                  <div className="message-content">
                    <div className="warning">
                      <img src={exclamationIcon} alt="" />
                      Admin users can only sign-in through Google
                    </div>
                    <div className="well">
                      <div className="googleLogo" />
                      <div className="stack">
                        <div className="title">Authenticated with Google</div>
                        <div className="username">{this.state.username}</div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="stack">
                    <Button
                      m="sp12"
                      data-testid="changePassword"
                      aria-label={"Change Password"}
                      onClick={this.handleChangePasswordQAuth}
                      variant="primary"
                      disabled={this.state.qauthPasswordEmailSent}
                    >
                      {"Change Password"}
                    </Button>
                    {this.state.qauthPasswordEmailSent && <label>Password reset email sent successfully </label>}
                  </div>
                )}
              </div>

              <div className="formgroup">
                <div className="formgroup_title">
                  <div className="formgroup_title_title">Phone Number</div>
                </div>
                <div className="formgroup-content">
                  <div className="mui-textfield account-phone-number">
                    <input type="tel" value={this.state.phoneNumber} onChange={this.handleChangePhoneNumber} />
                    <label>Phone Number</label>
                  </div>
                </div>
              </div>
            </form>
          </Box>
          <Box p="sp24" backgroundColor="brand.100" borderBottomRadius="sm">
            <Button variant="primary" disabled={this.state.saving || !this.state.changes} onClick={this.handleSave}>
              {this.state.saving ? "Saving.." : this.state.changes ? "Save" : "Saved"}
            </Button>
          </Box>
        </Box>
      </CardBasedPage>
    );
  };
}

export default withToast(Account);
